



// import React, { useState, useEffect, useRef } from "react";
// import "./NewPatientRegistration.css";

// const LabTestRequest = ({ screenAction, triggerSave }) => {
//   const [isDisabled, setIsDisabled] = useState(true);
//   const [searchText, setSearchText] = useState("");
//   const [patients, setPatients] = useState([]);
//   const [showDropdown, setShowDropdown] = useState(false);
//   // Add these right below your other useStates
//   const [patientSearchText, setPatientSearchText] = useState("");
//   const [patientResults, setPatientResults] = useState([]);
//   const [showPatientDropdown, setShowPatientDropdown] = useState(false);
//   // State for the list of tests to be requested
//   const [selectedTests, setSelectedTests] = useState([]);
//   const [testSearchResults, setTestSearchResults] = useState([]);
// const [showTestDropdown, setShowTestDropdown] = useState(false);
//   // Ref for the scanner input to keep it focused
//   const testInputRef = useRef(null);

//   const initialFormState = {
//     patient_id: "",
//     name: "",
//     gender: "",
//     doctor_name: "",
//     test_request_id: "", // Think of this as the "Master Order ID" now
//     test_date: "",
//     priority: "Normal",
    
//     // Temporary fields for the test currently being added
//     current_test_id: "",
//     current_test_name: "",
//     current_category: "",
//     current_fees: ""
//   };

//   const [formData, setFormData] = useState(initialFormState);

//   // --- 1. PATIENT SEARCH (Updated for Scanner) ---
//   const searchPatients = async (text) => {
//     setSearchText(text);
//     if (text.length < 2) {
//       setPatients([]);
//       setShowDropdown(false);
//       return;
//     }
//     const user = JSON.parse(localStorage.getItem("user"));
//     const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/lab-requests/search?q=${text}&employee_id=${user.id}`);
//     const data = await res.json();
//     setPatients(data);
//     setShowDropdown(true);
//   };

//   // const selectPatient = (patient) => {
//   //   setFormData(prev => ({
//   //     ...prev,
//   //     patient_id: patient.patient_id,
//   //     name: patient.name,
//   //     gender: patient.gender,
//   //     doctor_name: patient.doctor,
//   //     test_request_id: patient.test_request_id || prev.test_request_id, // Keep existing if new
//   //     test_date: patient.test_date ? patient.test_date.split("T")[0] : prev.test_date,
//   //     priority: patient.priority || "Normal",
//   //     _isExisting: !!patient.test_request_id 
//   //   }));

//   //   // If loading an existing request, populate the selectedTests table
//   //   if (patient.tests && Array.isArray(patient.tests)) {
//   //       setSelectedTests(patient.tests);
//   //   }

//   //   setSearchText(`${patient.name} | ${patient.patient_id}`);
//   //   setShowDropdown(false);
//   //   if (screenAction === "edit") setIsDisabled(false);
//   //   if (screenAction === "view") setIsDisabled(true);
//   // };

//   // --- 2. MULTIPLE TESTS LOGIC ---
//  const selectPatient = (patient) => {
//     setFormData(prev => ({
//       ...prev,
//       patient_id: patient.patient_id,
//       name: patient.name,
//       gender: patient.gender,
//       doctor_name: patient.doctor_name, // ✅ FIXED: Changed from patient.doctor
//       test_request_id: patient.test_request_id || prev.test_request_id,
//       test_date: patient.test_date ? patient.test_date.split("T")[0] : prev.test_date,
//       priority: patient.priority || "Normal",
//       _isExisting: !!patient.test_request_id 
//     }));

//     // ✅ FIXED: Safely load tests into the table, or clear it if none exist
//     if (patient.tests && Array.isArray(patient.tests) && patient.tests.length > 0) {
//         setSelectedTests(patient.tests);
//     } else {
//         setSelectedTests([]); // This ensures old data clears out!
//     }

//     setSearchText(`${patient.name} | ${patient.patient_id}`);
//     setShowDropdown(false);
//     if (screenAction === "edit") setIsDisabled(false);
//     if (screenAction === "view") setIsDisabled(true);
//   };


//   const loadAllTests = async () => {
//   try {
//     const res = await fetch(
//       `https://hmsapi.emedhatechnologies.com/master/api/api/tests/search`
//     );
//     const data = await res.json();

//     setTestSearchResults(data);
//     setShowTestDropdown(true);
//   } catch (err) {
//     console.error(err);
//   }
// };
 
// const selectTest = (t) => {
//   setFormData(prev => ({
//     ...prev,
//     current_test_id: t.test_id,
//     current_test_name: t.test_name,
//     current_category: t.category,
//     current_fees: t.fee
//   }));

//   setShowTestDropdown(false);
// };

// const handleTestSearch = async (value) => {
//   setFormData(prev => ({ ...prev, current_test_id: value }));

//   try {
//     const res = await fetch(
//       `https://hmsapi.emedhatechnologies.com/master/api/api/tests/search?q=${value}`
//     );
//     const data = await res.json();

//     setTestSearchResults(data);
//     setShowTestDropdown(true);
//   } catch (err) {
//     console.error(err);
//   }
// };
 
//   const fetchTestDetails = async (testId) => {
//     if (!testId) {
//       setFormData(prev => ({ ...prev, current_test_name: "", current_category: "", current_fees: "" }));
//       return;
//     }
//     try {
//       const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/ratecard/test/${testId}`);
//       if(res.ok){
//          const data = await res.json();
//          setFormData(prev => ({
//             ...prev,
//             current_test_name: data.test_name,
//             current_category: data.category,
//             current_fees: data.fees
//          }));
//       }
//     } catch (err) {
//       console.error("Error fetching test details");
//     }
//   };

//   const addTestToList = () => {
//     if (!formData.current_test_id || !formData.current_test_name) {
//       alert("Please enter a valid Test ID first.");
//       return;
//     }
    
//     // Prevent duplicates
//     if(selectedTests.some(t => t.test_id === formData.current_test_id)){
//         alert("This test is already in the list.");
//         return;
//     }

//     const newTest = {
//       test_id: formData.current_test_id,
//       test_name: formData.current_test_name,
//       category: formData.current_category,
//       fees: formData.current_fees || 0
//     };

//     setSelectedTests([...selectedTests, newTest]);

//     // Clear the temporary input fields so they can scan the next one
//     setFormData(prev => ({
//       ...prev,
//       current_test_id: "",
//       current_test_name: "",
//       current_category: "",
//       current_fees: ""
//     }));
    
//     // Focus back on the input for rapid scanning
//     if(testInputRef.current) testInputRef.current.focus();
//   };

//   const removeTestFromList = (testIdToRemove) => {
//     setSelectedTests(selectedTests.filter(t => t.test_id !== testIdToRemove));
//   };


//   // --- 3. FORM MANAGEMENT ---
//   const clearForm = () => {
//     const date = new Date();
//     const requestId = `TR-${date.getFullYear()}-${Math.floor(1000+Math.random()*9000)}`;
//     setFormData({
//       ...initialFormState,
//       test_request_id: requestId,
//       test_date: new Date().toISOString().split("T")[0]
//     });
//     setSelectedTests([]);
//     setSearchText("");
//     setIsDisabled(false);
//   };

//   useEffect(() => {
//     if (triggerSave > 0 && screenAction === "save") handleSubmit();
//   }, [triggerSave]);

//   useEffect(() => {
//     if (screenAction === "add") clearForm();
//     if (screenAction === "edit") setIsDisabled(false);
//     if (screenAction === "view") setIsDisabled(true);
//     if (screenAction === "refresh") clearForm();
//     if (screenAction === "print") printForm();
//   }, [screenAction]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//     if (name === "current_test_id") fetchTestDetails(value);
//   };

//   const handlePatientIdChange = async (value) => {
//     setFormData({ ...formData, patient_id: value });
//     if (value.length < 3) return;
//     try {
//       const user = JSON.parse(localStorage.getItem("user"));
//       const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/patient-by-id?patient_id=${value}&employee_id=${user.id}`);
//       const data = await res.json();
//       if (data && data.patient_id) {
//         setFormData((prev) => ({
//           ...prev,
//           patient_id: data.patient_id,
//           name: data.name,
//           gender: data.gender,
//           doctor_name: data.doctor,
//         }));
//       }
//     } catch (err) {
//       console.error("Patient fetch error:", err);
//     }
//   };


//   const handlePatientSearch = async (value) => {
//     setPatientSearchText(value);
//     setFormData({ ...formData, patient_id: value }); // Keep form data synced
    
//     if (value.length < 3) {
//       setPatientResults([]);
//       setShowPatientDropdown(false);
//       return;
//     }
    
//     try {
//       const user = JSON.parse(localStorage.getItem("user"));
//       // Make sure the URL matches your server setup! Note the ?q=${value}
//       const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/patient-by-id?q=${value}&employee_id=${user.id}`);
//       const data = await res.json();
      
//       setPatientResults(Array.isArray(data) ? data : []);
//       setShowPatientDropdown(true);
//     } catch (err) {
//       console.error("Patient fetch error:", err);
//     }
//   };

//   const selectPatientForForm = (patient) => {
//     setFormData((prev) => ({
//       ...prev,
//       patient_id: patient.patient_id,
//       name: patient.name,
//       gender: patient.gender,
//       doctor_name: patient.doctor_name || "", // Fills from the latest appointment!
//     }));
    
//     setPatientSearchText(patient.patient_id); // Show ID in the input box
//     setShowPatientDropdown(false);
//   };

//   // --- 4. SAVE LOGIC (Sending Array of Tests) ---
//   const handleSubmit = async () => {
//     const user = JSON.parse(localStorage.getItem("user"));
//     if (!formData.patient_id) return alert("Patient required");
//     if (selectedTests.length === 0) return alert("Please add at least one test.");

//     // We send the master details PLUS the array of selected tests
//     const payload = {
//       patient_id: formData.patient_id,
//       name: formData.name,               // ✅ ADDED THIS
//       gender: formData.gender,           // ✅ ADDED THIS
//       doctor_name: formData.doctor_name, // ✅ ADDED THIS
//       test_request_id: formData.test_request_id,
//       test_date: formData.test_date,
//       priority: formData.priority,
//       created_by: user.id,
//       tests: selectedTests // The array of tests!
//     };

//     const method = formData._isExisting ? "PUT" : "POST";
//     const url = method === "POST"
//         ? "https://hmsapi.emedhatechnologies.com/master/api/api/lab-request"
//         : `https://hmsapi.emedhatechnologies.com/master/api/api/lab-request/${formData.test_request_id}`;

//     try {
//       const res = await fetch(url, {
//         method,
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload)
//       });
//       if (res.ok) {
//         alert("Lab Test Request Saved");
//         if (method === "POST") clearForm();
//       } else {
//         alert("Error saving");
//       }
//     } catch (err) {
//       alert("Network error");
//     }
//   };

// // --- 5. PRINT FORM (Includes Barcode & Multiple Tests) ---
//   const printForm = () => {
//     const newWindow = window.open("", "", "width=900,height=700");
//     const today = new Date().toLocaleDateString();
    
//     // Calculate Total Fees
//     const totalFees = selectedTests.reduce((sum, test) => sum + parseFloat(test.fees || 0), 0);

//     const htmlContent = `
//       <html>
//         <head>
//           <title>Lab Requisition - ${formData.test_request_id}</title>
//           <style>
//             body { font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; color: #333; margin: 0; padding: 40px; }
//             .header { display: flex; justify-content: space-between; align-items: center; border-bottom: 2px solid #4b0082; padding-bottom: 10px; margin-bottom: 20px; }
//             .hospital-info h1 { margin: 0; color: #2c3e50; font-size: 24px; text-transform: uppercase; }
//             .hospital-info p { margin: 2px 0; font-size: 12px; color: #7f8c8d; }
//             .report-title { text-align: right; }
//             .report-title h2 { margin: 0; color: #4b0082; font-size: 18px; }
//             .section-header { background: #f4f0fa; padding: 8px 12px; font-weight: bold; font-size: 14px; border-left: 4px solid #4b0082; margin-top: 20px; margin-bottom: 10px; text-transform: uppercase; }
//             .data-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 10px; margin-bottom: 10px; }
//             .data-item { font-size: 13px; display: flex; border-bottom: 1px dotted #ccc; padding: 6px 0; }
//             .label { font-weight: 600; width: 160px; color: #555; }
//             .value { flex: 1; color: #000; font-weight: 500; }
            
//             /* Table for Multiple Tests */
//             table { width: 100%; border-collapse: collapse; margin-top: 15px; font-size: 13px; }
//             th, td { border: 1px solid #ccc; padding: 8px; text-align: left; }
//             th { background-color: #f4f0fa; }
            
//             .priority-tag { display: inline-block; padding: 2px 8px; border-radius: 4px; font-size: 11px; font-weight: bold; text-transform: uppercase; color: white; background: ${formData.priority === 'Urgent' || formData.priority === 'Emergency' ? '#e74c3c' : '#4b0082'}; }
//             .footer { margin-top: 50px; font-size: 10px; text-align: center; color: #95a5a6; border-top: 1px solid #eee; padding-top: 10px; }
//             .sig-box { margin-top: 60px; display: flex; justify-content: space-between; }
//             .sig { border-top: 1px solid #000; width: 200px; text-align: center; padding-top: 5px; font-size: 12px; }
//           </style>
//         </head>
//         <body>
//        <div class="header" style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
            
//             <div class="hospital-info" style="flex: 1; text-align: left;">
//               <h1 style="margin: 0; color: #2c3e50; font-size: 20px; text-transform: uppercase;">EMEDHA CARE HOSPITAL</h1>
//               <p style="margin: 2px 0; font-size: 11px; color: #7f8c8d;">Phone: +91 98765 43210</p>
//               <p style="margin: 2px 0; font-size: 11px; color: #7f8c8d;">Email: diagnostics@citycare.com</p>
//             </div>
            
//             <div style="flex: 1; text-align: center; display: flex; flex-direction: column; align-items: center; justify-content: center;">
//                <img 
//                  src="https://bwipjs-api.metafloor.com/?bcid=code128&text=${formData.test_request_id}&scale=2&height=10" 
//                  alt="Barcode" 
//                  style="height: 40px; max-width: 100%;"
//                  onload="window.print(); window.close();" 
//                  onerror="window.print(); window.close();"
//                />
//                <p style="margin:4px 0 0 0; font-size:11px; font-weight: bold; letter-spacing: 1px;">${formData.test_request_id}</p>
//             </div>

//             <div class="report-title" style="flex: 1; text-align: right;">
//               <h2 style="margin: 0; color: #4b0082; font-size: 18px;">LAB REQUISITION</h2>
//               <p style="margin: 4px 0 0 0; font-size: 12px; font-weight: bold;">Date: ${formData.test_date || today}</p>
//             </div>

//           </div>

//           <div class="section-header">Patient Information</div>
//           <div class="data-grid">
//             <div class="data-item"><span class="label">Patient ID:</span> <span class="value">${formData.patient_id}</span></div>
//             <div class="data-item"><span class="label">Patient Name:</span> <span class="value">${formData.name || 'N/A'}</span></div>
//             <div class="data-item"><span class="label">Gender:</span> <span class="value">${formData.gender || 'N/A'}</span></div>
//             <div class="data-item"><span class="label">Referring Doctor:</span> <span class="value">Dr. ${formData.doctor_name || 'N/A'}</span></div>
//             <div class="data-item"><span class="label">Priority:</span> <span class="value"><span class="priority-tag">${formData.priority}</span></span></div>
//           </div>

//           <div class="section-header">Requested Tests</div>
//           <table>
//             <thead>
//               <tr>
//                 <th>Test ID</th>
//                 <th>Test Name</th>
//                 <th>Category</th>
//                 <th>Fees (₹)</th>
//               </tr>
//             </thead>
//             <tbody>
//               ${selectedTests.map(test => `
//                 <tr>
//                   <td>${test.test_id}</td>
//                   <td>${test.test_name}</td>
//                   <td>${test.category}</td>
//                   <td>${parseFloat(test.fees).toFixed(2)}</td>
//                 </tr>
//               `).join('')}
//               <tr>
//                 <td colspan="3" style="text-align: right; font-weight: bold;">Total Fees:</td>
//                 <td style="font-weight: bold;">₹ ${totalFees.toFixed(2)}</td>
//               </tr>
//             </tbody>
//           </table>

//           <div class="sig-box">
//             <div class="sig">Doctor's Signature</div>
//             <div class="sig">Lab Technician</div>
//           </div>
//           <div class="footer">
//             Samples must be collected within 24 hours of requisition. 
//           </div>
//         </body>
//       </html>
//     `;

//     newWindow.document.write(htmlContent);
//     newWindow.document.close();
    
//     // Removed the setTimeout here because the image's 'onload' handles the printing now!
//   };

//   // --- 6. PRINT BARCODE LABELS (For Sample Vials) ---
//   const printLabels = () => {
//     if (!formData.test_request_id || selectedTests.length === 0) {
//       alert("No tests available to print labels for.");
//       return;
//     }

//     const newWindow = window.open("", "", "width=400,height=400");
//     const today = new Date().toLocaleDateString();

//     // Loop through tests and create a tiny label for each one
//     const labelsHtml = selectedTests.map((test) => `
//       <div class="label-container">
//         <div class="label-header">
//           <span class="patient-name">${formData.name ? formData.name.substring(0, 15) : 'UNKNOWN'}</span>
//           <span class="patient-id">${formData.patient_id}</span>
//         </div>
        
//         <div class="test-name">${test.test_name.substring(0, 25)}</div>
        
//         <div class="barcode-box">
//           <img 
//             src="https://bwipjs-api.metafloor.com/?bcid=code128&text=${formData.test_request_id}&scale=2&height=8" 
//             alt="Barcode" 
//           />
//           <div class="barcode-text">${formData.test_request_id}</div>
//         </div>

//         <div class="label-footer">
//           <span>${today}</span>
//           <span>${formData.gender ? formData.gender.charAt(0) : ''}</span>
//         </div>
//       </div>
//     `).join('');

//     const htmlContent = `
//       <html>
//         <head>
//           <title>Print Labels</title>
//           <style>
//             body { 
//               font-family: Arial, sans-serif; 
//               margin: 0; 
//               padding: 0; 
//               background: #fff; 
//             }
            
//             /* Industry standard blood vial label size: 50mm x 25mm */
//             @page { 
//               size: 50mm 25mm; 
//               margin: 0; 
//             }
            
//             .label-container {
//               width: 48mm;
//               height: 23mm;
//               padding: 1mm;
//               box-sizing: border-box;
//               page-break-after: always; /* Forces printer to roll to the next sticker */
//               display: flex;
//               flex-direction: column;
//               justify-content: space-between;
//               overflow: hidden;
//             }
            
//             .label-header { 
//               display: flex; 
//               justify-content: space-between; 
//               font-size: 8px; 
//               font-weight: bold; 
//               margin-bottom: 1px; 
//             }
            
//             .patient-name { text-transform: uppercase; }
            
//             .test-name { 
//               font-size: 9px; 
//               font-weight: bold; 
//               text-align: center; 
//               white-space: nowrap; 
//               overflow: hidden; 
//               text-overflow: ellipsis; 
//             }
            
//             .barcode-box { 
//               text-align: center; 
//               margin: 1px 0; 
//             }
            
//             .barcode-box img { 
//               height: 8mm; /* Very short barcode to fit the sticker */
//               max-width: 100%; 
//             }
            
//             .barcode-text { 
//               font-size: 7px; 
//               font-weight: bold; 
//               letter-spacing: 1px; 
//             }
            
//             .label-footer { 
//               font-size: 7px; 
//               display: flex; 
//               justify-content: space-between; 
//             }
//           </style>
//         </head>
//         <body onload="setTimeout(function(){ window.print(); window.close(); }, 700);">
//           ${labelsHtml}
//         </body>
//       </html>
//     `;

//     newWindow.document.write(htmlContent);
//     newWindow.document.close();
//   };



//   return(
//     <div className="registration-container fade-in" id="print-area">
      
//       {/* PATIENT SEARCH (With Scanner Support) */}
//       {(screenAction==="edit" || screenAction==="view") && (
//         <div className="patient-search">
//           <label>Scan Barcode or Search Patient</label>
//           <input
//             type="text"
//             value={searchText}
//             placeholder="Scan Request ID or Search by Name..."
//             onChange={(e)=>searchPatients(e.target.value)}
//             // --- SCANNER MAGIC HERE ---
//             onKeyDown={(e) => {
//                 if (e.key === 'Enter') {
//                   e.preventDefault();
//                   if (patients.length === 1) selectPatient(patients[0]);
//                 }
//             }}
//             autoFocus
//           />
//           {showDropdown && patients.length>0 &&(
//             <div className="patient-dropdown">
//               {patients.map(p=>(
//                 <div key={p.patient_id} className="patient-item" onClick={()=>selectPatient(p)}>
//                   {p.name} | {p.patient_id} | Req: {p.test_request_id}
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>
//       )}

//       <form className="luxury-form">
        
//         {/* PATIENT DETAILS */}
//         <div className="form-section-header">
//           <h3>Patient Details</h3>
//         </div>
//         <div className="form-grid">
//          <div className="input-box" style={{ position: 'relative' }}>
//   <label>Patient ID / Name / Mobile</label>
//   <input 
//      type="text" 
//      value={patientSearchText || formData.patient_id} 
//      onChange={(e) => handlePatientSearch(e.target.value)} 
//      placeholder="Search..."
//      disabled={isDisabled}
//      autoComplete="off"
//   />
//   {/* The Dropdown Menu */}
//   {showPatientDropdown && patientResults.length > 0 && (
//     <div className="patient-dropdown" style={{ top: '100%', left: 0, width: '100%', zIndex: 100 }}>
//       {patientResults.map(p => (
//         <div key={p.patient_id} className="patient-item" onClick={() => selectPatientForForm(p)}>
//           {p.name} | {p.mobile} | {p.patient_id}
//         </div>
//       ))}
//     </div>
//   )}
// </div>
//           <div className="input-box"><label>Name</label><input type="text" value={formData.name} readOnly/></div>
//           <div className="input-box"><label>Gender</label><input type="text" value={formData.gender} readOnly/></div>
//           <div className="input-box"><label>Doctor</label><input type="text" value={formData.doctor_name} readOnly/></div>
//         </div>

//         {/* TEST REQUEST HEADER */}
//         <div className="form-section-header">
//           <h3>Lab Test Details</h3>
//         </div>
//         <div className="form-grid">
//           <div className="input-box read-only"><label>Master Request ID</label><input type="text" value={formData.test_request_id} readOnly/></div>
//           <div className="input-box"><label>Request Date</label><input type="date" name="test_date" value={formData.test_date} onChange={handleChange} disabled={isDisabled}/></div>
//           <div className="input-box"><label>Priority</label>
//             <select name="priority" value={formData.priority} onChange={handleChange} disabled={isDisabled}>
//               <option>Normal</option><option>Urgent</option><option>Emergency</option>
//             </select>
//           </div>
//         </div>

//         {/* ADD TESTS TO CART (With Scanner Support) */}
//         <div className="form-section-header" style={{ marginTop: '20px', borderTop: '1px solid #ccc', paddingTop: '10px' }}>
//           <h4>Add Tests</h4>
//         </div>
//         <div className="form-grid" style={{ alignItems: 'flex-end', backgroundColor: '#f9f9f9', padding: '15px', borderRadius: '8px' }}>
//           {/* <div className="input-box">
//             <label>Scan or Enter Test ID</label>
//             <input
//               type="text"
//               name="current_test_id"
//               value={formData.current_test_id}
//               onChange={handleChange}
//               disabled={isDisabled}
//               ref={testInputRef}
//               // --- SCANNER MAGIC HERE FOR ADDING TESTS ---
//               onKeyDown={(e) => {
//                 if (e.key === 'Enter') {
//                   e.preventDefault();
//                   addTestToList(); // Auto-add when scanner hits Enter
//                 }
//               }}
//             />
//           </div> */}
//           <div className="input-box" style={{ position: "relative" , position: "relative", 
//   overflow: "visible"}}>
//   <label>Search Test</label>

//   <input
//     type="text"
//     value={formData.current_test_id}
//     placeholder="Search Test ID / Name..."
//     onFocus={loadAllTests}   // ✅ SHOW ALL FIRST
//     onChange={(e) => handleTestSearch(e.target.value)}
//     ref={testInputRef}
//     disabled={isDisabled}
    
//   />

//   {/* DROPDOWN */}
//   {showTestDropdown && (
//     <div
//       style={{
//         position: "absolute",
//         top: "100%",
//         left: 0,
//         width: "100%",
//         background: "#fff",
//         border: "1px solid #ccc",
//         borderRadius: "6px",
//           zIndex: 9999,      
//         maxHeight: "220px",
//         overflowY: "auto"
//       }}
//     >
//       {testSearchResults.map((t) => (
//         <div
//           key={t.test_id}
//           onClick={() => selectTest(t)}
//           style={{
//             padding: "8px",
//             cursor: "pointer",
//             borderBottom: "1px solid #eee"
//           }}
//         >
//           <strong>{t.test_name}</strong><br/>
//           <small>{t.test_id} | {t.category} | ₹{t.fee}</small>
//         </div>
//       ))}
//     </div>
//   )}
// </div>
//           <div className="input-box"><label>Test Name</label><input type="text" value={formData.current_test_name} readOnly/></div>
//           <div className="input-box"><label>Fees</label><input type="text" value={formData.current_fees} readOnly/></div>
          
//           <button 
//              type="button" 
//              onClick={addTestToList} 
//              disabled={isDisabled || !formData.current_test_name}
//              style={{ padding: '10px 20px', height: '40px', backgroundColor: '#4b0082', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>
//              + Add Test
//           </button>
//         </div>

//         {/* SELECTED TESTS TABLE */}
//      {/* SELECTED TESTS TABLE & LABEL BUTTON */}
//         {selectedTests.length > 0 && (
//           <div style={{ marginTop: '20px' }}>
            
//             {/* NEW HEADER WITH PRINT BUTTON */}
//             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
//               <h4 style={{ margin: 0 }}>Selected Tests List</h4>
//               <button 
//                 type="button" 
//                 onClick={printLabels} 
//                 style={{ padding: '6px 12px', backgroundColor: '#28a745', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold', fontSize: '12px' }}
//               >
//                 🖨️ Print Vial Labels
//               </button>
//             </div>

//             <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
//               <thead style={{ backgrousndColor: '#e9ecef', borderBottom: '2px solid #ccc' }}>
//                 <tr>
//                   <th style={{ padding: '10px' }}>Test ID</th>
//                   <th style={{ padding: '10px' }}>Test Name</th>
//                   <th style={{ padding: '10px' }}>Category</th>
//                   <th style={{ padding: '10px' }}>Fees</th>
//                   <th style={{ padding: '10px', textAlign: 'center' }}>Action</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {selectedTests.map((test, index) => (
//                   <tr key={index} style={{ borderBottom: '1px solid #ddd' }}>
//                     <td style={{ padding: '10px' }}>{test.test_id}</td>
//                     <td style={{ padding: '10px' }}>{test.test_name}</td>
//                     <td style={{ padding: '10px' }}>{test.category}</td>
//                     <td style={{ padding: '10px' }}>₹{test.fees}</td>
//                     <td style={{ padding: '10px', textAlign: 'center' }}>
//                       {!isDisabled && (
//                          <button type="button" onClick={() => removeTestFromList(test.test_id)} style={{ color: 'red', border: 'none', background: 'none', cursor: 'pointer', fontWeight: 'bold' }}>X</button>
//                       )}
//                     </td>
//                   </tr>
//                 ))}
//                 <tr style={{ borderTop: '2px solid #999', backgroundColor: '#f8f9fa' }}>
//       <td colSpan="3" style={{ padding: '10px', textAlign: 'right', fontWeight: 'bold' }}>
//         Total Amount:
//       </td>
//       <td style={{ padding: '10px', fontWeight: 'bold', color: '#27ae60' }}>
//         ₹{selectedTests.reduce((sum, test) => sum + parseFloat(test.fees || 0), 0).toFixed(2)}
//       </td>
//       <td></td> {/* Empty cell under the Action column to keep grid aligned */}
//     </tr>
//               </tbody>
//             </table>
//           </div>
//         )}

//       </form>
//     </div>
//   );
// };

// export default LabTestRequest;


import React, { useState, useEffect, useRef } from "react";
import "./NewPatientRegistration.css";

const LabTestRequest = ({ screenAction, triggerSave }) => {
  const [isDisabled, setIsDisabled] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [patients, setPatients] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  // Add these right below your other useStates
  const [patientSearchText, setPatientSearchText] = useState("");
  const [patientResults, setPatientResults] = useState([]);
  const [showPatientDropdown, setShowPatientDropdown] = useState(false);
  // State for the list of tests to be requested
  const [selectedTests, setSelectedTests] = useState([]);
  const [testSearchResults, setTestSearchResults] = useState([]);
const [showTestDropdown, setShowTestDropdown] = useState(false);


const [categoriesList, setCategoriesList] = useState([]);
  const [allMasterTests, setAllMasterTests] = useState([]);
  const [filteredTests, setFilteredTests] = useState([]);


  // Ref for the scanner input to keep it focused
  const testInputRef = useRef(null);

  const initialFormState = {
    patient_id: "",
    name: "",
    gender: "",
    doctor_name: "",
    test_request_id: "", // Think of this as the "Master Order ID" now
    test_date: "",
    priority: "Normal",
    
    // Temporary fields for the test currently being added
    current_test_id: "",
    current_test_name: "",
    current_category: "",
    current_fees: ""
  };

  const [formData, setFormData] = useState(initialFormState);

  // --- 1. PATIENT SEARCH (Updated for Scanner) ---
  const searchPatients = async (text) => {
    setSearchText(text);
    if (text.length < 2) {
      setPatients([]);
      setShowDropdown(false);
      return;
    }
    const user = JSON.parse(localStorage.getItem("user"));
    const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/lab-requests/search?q=${text}&employee_id=${user.id}`);
    const data = await res.json();
    setPatients(data);
    setShowDropdown(true);
  };

 

  // --- 2. MULTIPLE TESTS LOGIC ---
 const selectPatient = (patient) => {
    setFormData(prev => ({
      ...prev,
      patient_id: patient.patient_id,
      name: patient.name,
      gender: patient.gender,
      doctor_name: patient.doctor_name, // ✅ FIXED: Changed from patient.doctor
      test_request_id: patient.test_request_id || prev.test_request_id,
      test_date: patient.test_date ? patient.test_date.split("T")[0] : prev.test_date,
      priority: patient.priority || "Normal",
      _isExisting: !!patient.test_request_id 
    }));

    // ✅ FIXED: Safely load tests into the table, or clear it if none exist
    if (patient.tests && Array.isArray(patient.tests) && patient.tests.length > 0) {
        setSelectedTests(patient.tests);
    } else {
        setSelectedTests([]); // This ensures old data clears out!
    }

    setSearchText(`${patient.name} | ${patient.patient_id}`);
    setShowDropdown(false);
    if (screenAction === "edit") setIsDisabled(false);
    if (screenAction === "view") setIsDisabled(true);
  };


  const loadAllTests = async () => {
  try {
    const res = await fetch(
      `https://hmsapi.emedhatechnologies.com/master/api/api/tests/search`
    );
    const data = await res.json();

    setTestSearchResults(data);
    setShowTestDropdown(true);
  } catch (err) {
    console.error(err);
  }
};
 
const selectTest = (t) => {
  setFormData(prev => ({
    ...prev,
    current_test_id: t.test_id,
    current_test_name: t.test_name,
    current_category: t.category,
    current_fees: t.fee
  }));

  setShowTestDropdown(false);
};



useEffect(() => {
    const fetchMasterData = async () => {
      try {
        const user = JSON.parse(localStorage.getItem("user"));
        const [catRes, testRes] = await Promise.all([
          fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/test-categories?employee_id=${user.id}`),
          fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/tests?employee_id=${user.id}`)
        ]);

        if (catRes.ok) {
          const catData = await catRes.json();
          // Only store active categories
          setCategoriesList(catData.filter(c => c.status === "Active"));
        }
        if (testRes.ok) {
          const testData = await testRes.json();
          // Only store active tests
          setAllMasterTests(testData.filter(t => t.status === "Active"));
        }
      } catch (err) {
        console.error("Error fetching master data:", err);
      }
    };

    fetchMasterData();
  }, []);



const handleCategorySelect = (e) => {
    const selectedCatName = e.target.value;
    
    // 1. Update form and clear any previously selected test
    setFormData(prev => ({
      ...prev,
      current_category: selectedCatName,
      current_test_id: "",
      current_test_name: "",
      current_fees: ""
    }));

    // 2. Filter tests based on selected category
    if (selectedCatName) {
      const catObj = categoriesList.find(c => c.test_category_name === selectedCatName);
      if (catObj) {
        const filtered = allMasterTests.filter(t => t.test_category_id === catObj.test_category_id);
        setFilteredTests(filtered);
      }
    } else {
      setFilteredTests([]);
    }
};


const handleTestDropdownSelect = (e) => {
    const selectedTestName = e.target.value;
    const testObj = filteredTests.find(t => t.test_name === selectedTestName);
    
    if (testObj) {
      setFormData(prev => ({
        ...prev,
        // We only set the name here. We let fetchTestDetails handle setting the correct T001 ID!
        current_test_name: testObj.test_name 
      }));
      
      // Fetch the rate and the Rate Card ID (T001)
      fetchTestDetails(testObj.test_name);
      
    } else {
      setFormData(prev => ({
        ...prev,
        current_test_id: "",
        current_test_name: "",
        current_fees: ""
      }));
    }
  };

const handleTestSearch = async (value) => {
  setFormData(prev => ({ ...prev, current_test_id: value }));

  try {
    const res = await fetch(
      `https://hmsapi.emedhatechnologies.com/master/api/api/tests/search?q=${value}`
    );
    const data = await res.json();

    setTestSearchResults(data);
    setShowTestDropdown(true);
  } catch (err) {
    console.error(err);
  }
};
 
const fetchTestDetails = async (testName) => {
    if (!testName) {
      setFormData(prev => ({ ...prev, current_fees: "" }));
      return;
    }
    try {
      // Safely encode the test name for the URL query
      const encodedName = encodeURIComponent(testName);
      
      // 🔥 THE FIX: Pass it as ?name= instead of a slash path
      const res = await fetch(` https://hmsapi.emedhatechnologies.com/master/api/api/ratecard/test?name=${encodedName}`);
      
      if (res.ok) {
         const data = await res.json();
         const rateData = Array.isArray(data) ? data[0] : data;

         setFormData(prev => ({
            ...prev,
            current_fees: rateData?.fees || rateData?.fee || "0",
            current_test_id: rateData?.test_id || prev.current_test_id
         }));
      } else {
         setFormData(prev => ({ ...prev, current_fees: "0" }));
      }
    } catch (err) {
      console.error("Error fetching test details:", err);
      setFormData(prev => ({ ...prev, current_fees: "0" }));
    }
  };

  const addTestToList = () => {
    if (!formData.current_test_id || !formData.current_test_name) {
      alert("Please enter a valid Test ID first.");
      return;
    }
    
    // Prevent duplicates
    if(selectedTests.some(t => t.test_id === formData.current_test_id)){
        alert("This test is already in the list.");
        return;
    }

    const newTest = {
      test_id: formData.current_test_id,
      test_name: formData.current_test_name,
      category: formData.current_category,
      fees: formData.current_fees || 0
    };

    setSelectedTests([...selectedTests, newTest]);

    // Clear the temporary input fields so they can scan the next one
    setFormData(prev => ({
      ...prev,
      current_test_id: "",
      current_test_name: "",
      current_category: "",
      current_fees: ""
    }));
    
    // Focus back on the input for rapid scanning
    if(testInputRef.current) testInputRef.current.focus();
  };

  const removeTestFromList = (testIdToRemove) => {
    setSelectedTests(selectedTests.filter(t => t.test_id !== testIdToRemove));
  };


  // --- 3. FORM MANAGEMENT ---
  const clearForm = () => {
    const date = new Date();
    const requestId = `TR-${date.getFullYear()}-${Math.floor(1000+Math.random()*9000)}`;
    setFormData({
      ...initialFormState,
      test_request_id: requestId,
      test_date: new Date().toISOString().split("T")[0]
    });
    setSelectedTests([]);
    setSearchText("");
    setIsDisabled(false);
  };

  useEffect(() => {
    if (triggerSave > 0 && screenAction === "save") handleSubmit();
  }, [triggerSave]);

  useEffect(() => {
    if (screenAction === "add") clearForm();
    if (screenAction === "edit") setIsDisabled(false);
    if (screenAction === "view") setIsDisabled(true);
    if (screenAction === "refresh") clearForm();
    if (screenAction === "print") printForm();
  }, [screenAction]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    if (name === "current_test_id") fetchTestDetails(value);
  };

  const handlePatientIdChange = async (value) => {
    setFormData({ ...formData, patient_id: value });
    if (value.length < 3) return;
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/patient-by-id?patient_id=${value}&employee_id=${user.id}`);
      const data = await res.json();
      if (data && data.patient_id) {
        setFormData((prev) => ({
          ...prev,
          patient_id: data.patient_id,
          name: data.name,
          gender: data.gender,
          doctor_name: data.doctor,
        }));
      }
    } catch (err) {
      console.error("Patient fetch error:", err);
    }
  };


  const handlePatientSearch = async (value) => {
    setPatientSearchText(value);
    setFormData({ ...formData, patient_id: value }); // Keep form data synced
    
    if (value.length < 3) {
      setPatientResults([]);
      setShowPatientDropdown(false);
      return;
    }
    
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      // Make sure the URL matches your server setup! Note the ?q=${value}
      const res = await fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/patient-by-id?q=${value}&employee_id=${user.id}`);
      const data = await res.json();
      
      setPatientResults(Array.isArray(data) ? data : []);
      setShowPatientDropdown(true);
    } catch (err) {
      console.error("Patient fetch error:", err);
    }
  };

  const selectPatientForForm = (patient) => {
    setFormData((prev) => ({
      ...prev,
      patient_id: patient.patient_id,
      name: patient.name,
      gender: patient.gender,
      doctor_name: patient.doctor_name || "", // Fills from the latest appointment!
    }));
    
    setPatientSearchText(patient.patient_id); // Show ID in the input box
    setShowPatientDropdown(false);
  };

  // --- 4. SAVE LOGIC (Sending Array of Tests) ---
  const handleSubmit = async () => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!formData.patient_id) return alert("Patient required");
    if (selectedTests.length === 0) return alert("Please add at least one test.");

    // We send the master details PLUS the array of selected tests
    const payload = {
      patient_id: formData.patient_id,
      name: formData.name,               // ✅ ADDED THIS
      gender: formData.gender,           // ✅ ADDED THIS
      doctor_name: formData.doctor_name, // ✅ ADDED THIS
      test_request_id: formData.test_request_id,
      test_date: formData.test_date,
      priority: formData.priority,
      created_by: user.id,
      tests: selectedTests // The array of tests!
    };

    const method = formData._isExisting ? "PUT" : "POST";
    const url = method === "POST"
        ? "https://hmsapi.emedhatechnologies.com/master/api/api/lab-request"
        : `https://hmsapi.emedhatechnologies.com/master/api/api/lab-request/${formData.test_request_id}`;

    try {
      const res = await fetch(url, {
        method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });
      if (res.ok) {
        alert("Lab Test Request Saved");
        if (method === "POST") clearForm();
      } else {
        alert("Error saving");
      }
    } catch (err) {
      alert("Network error");
    }
  };

// --- 5. PRINT FORM (Includes Barcode & Multiple Tests) ---
  const printForm = () => {
    const newWindow = window.open("", "", "width=900,height=700");
    const today = new Date().toLocaleDateString();
    
    // Calculate Total Fees
    const totalFees = selectedTests.reduce((sum, test) => sum + parseFloat(test.fees || 0), 0);

    const htmlContent = `
      <html>
        <head>
          <title>Lab Requisition - ${formData.test_request_id}</title>
          <style>
            body { font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; color: #333; margin: 0; padding: 40px; }
            .header { display: flex; justify-content: space-between; align-items: center; border-bottom: 2px solid #4b0082; padding-bottom: 10px; margin-bottom: 20px; }
            .hospital-info h1 { margin: 0; color: #2c3e50; font-size: 24px; text-transform: uppercase; }
            .hospital-info p { margin: 2px 0; font-size: 12px; color: #7f8c8d; }
            .report-title { text-align: right; }
            .report-title h2 { margin: 0; color: #4b0082; font-size: 18px; }
            .section-header { background: #f4f0fa; padding: 8px 12px; font-weight: bold; font-size: 14px; border-left: 4px solid #4b0082; margin-top: 20px; margin-bottom: 10px; text-transform: uppercase; }
            .data-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 10px; margin-bottom: 10px; }
            .data-item { font-size: 13px; display: flex; border-bottom: 1px dotted #ccc; padding: 6px 0; }
            .label { font-weight: 600; width: 160px; color: #555; }
            .value { flex: 1; color: #000; font-weight: 500; }
            
            /* Table for Multiple Tests */
            table { width: 100%; border-collapse: collapse; margin-top: 15px; font-size: 13px; }
            th, td { border: 1px solid #ccc; padding: 8px; text-align: left; }
            th { background-color: #f4f0fa; }
            
            .priority-tag { display: inline-block; padding: 2px 8px; border-radius: 4px; font-size: 11px; font-weight: bold; text-transform: uppercase; color: white; background: ${formData.priority === 'Urgent' || formData.priority === 'Emergency' ? '#e74c3c' : '#4b0082'}; }
            .footer { margin-top: 50px; font-size: 10px; text-align: center; color: #95a5a6; border-top: 1px solid #eee; padding-top: 10px; }
            .sig-box { margin-top: 60px; display: flex; justify-content: space-between; }
            .sig { border-top: 1px solid #000; width: 200px; text-align: center; padding-top: 5px; font-size: 12px; }
          </style>
        </head>
        <body>
       <div class="header" style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
            
            <div class="hospital-info" style="flex: 1; text-align: left;">
              <h1 style="margin: 0; color: #2c3e50; font-size: 20px; text-transform: uppercase;">EMEDHA CARE HOSPITAL</h1>
              <p style="margin: 2px 0; font-size: 11px; color: #7f8c8d;">Phone: +91 98765 43210</p>
              <p style="margin: 2px 0; font-size: 11px; color: #7f8c8d;">Email: diagnostics@citycare.com</p>
            </div>
            
            <div style="flex: 1; text-align: center; display: flex; flex-direction: column; align-items: center; justify-content: center;">
               <img 
                 src="https://bwipjs-api.metafloor.com/?bcid=code128&text=${formData.test_request_id}&scale=2&height=10" 
                 alt="Barcode" 
                 style="height: 40px; max-width: 100%;"
                 onload="window.print(); window.close();" 
                 onerror="window.print(); window.close();"
               />
               <p style="margin:4px 0 0 0; font-size:11px; font-weight: bold; letter-spacing: 1px;">${formData.test_request_id}</p>
            </div>

            <div class="report-title" style="flex: 1; text-align: right;">
              <h2 style="margin: 0; color: #4b0082; font-size: 18px;">LAB REQUISITION</h2>
              <p style="margin: 4px 0 0 0; font-size: 12px; font-weight: bold;">Date: ${formData.test_date || today}</p>
            </div>

          </div>

          <div class="section-header">Patient Information</div>
          <div class="data-grid">
            <div class="data-item"><span class="label">Patient ID:</span> <span class="value">${formData.patient_id}</span></div>
            <div class="data-item"><span class="label">Patient Name:</span> <span class="value">${formData.name || 'N/A'}</span></div>
            <div class="data-item"><span class="label">Gender:</span> <span class="value">${formData.gender || 'N/A'}</span></div>
            <div class="data-item"><span class="label">Referring Doctor:</span> <span class="value">Dr. ${formData.doctor_name || 'N/A'}</span></div>
            <div class="data-item"><span class="label">Priority:</span> <span class="value"><span class="priority-tag">${formData.priority}</span></span></div>
          </div>

          <div class="section-header">Requested Tests</div>
          <table>
            <thead>
              <tr>
                <th>Test ID</th>
                <th>Test Name</th>
                <th>Category</th>
                <th>Fees (₹)</th>
              </tr>
            </thead>
            <tbody>
              ${selectedTests.map(test => `
                <tr>
                  <td>${test.test_id}</td>
                  <td>${test.test_name}</td>
                  <td>${test.category}</td>
                  <td>${parseFloat(test.fees).toFixed(2)}</td>
                </tr>
              `).join('')}
              <tr>
                <td colspan="3" style="text-align: right; font-weight: bold;">Total Fees:</td>
                <td style="font-weight: bold;">₹ ${totalFees.toFixed(2)}</td>
              </tr>
            </tbody>
          </table>

          <div class="sig-box">
            <div class="sig">Doctor's Signature</div>
            <div class="sig">Lab Technician</div>
          </div>
          <div class="footer">
            Samples must be collected within 24 hours of requisition. 
          </div>
        </body>
      </html>
    `;

    newWindow.document.write(htmlContent);
    newWindow.document.close();
    
    // Removed the setTimeout here because the image's 'onload' handles the printing now!
  };

  // --- 6. PRINT BARCODE LABELS (For Sample Vials) ---
  const printLabels = () => {
    if (!formData.test_request_id || selectedTests.length === 0) {
      alert("No tests available to print labels for.");
      return;
    }

    const newWindow = window.open("", "", "width=400,height=400");
    const today = new Date().toLocaleDateString();

    // Loop through tests and create a tiny label for each one
    const labelsHtml = selectedTests.map((test) => `
      <div class="label-container">
        <div class="label-header">
          <span class="patient-name">${formData.name ? formData.name.substring(0, 15) : 'UNKNOWN'}</span>
          <span class="patient-id">${formData.patient_id}</span>
        </div>
        
        <div class="test-name">${test.test_name.substring(0, 25)}</div>
        
        <div class="barcode-box">
          <img 
            src="https://bwipjs-api.metafloor.com/?bcid=code128&text=${formData.test_request_id}&scale=2&height=8" 
            alt="Barcode" 
          />
          <div class="barcode-text">${formData.test_request_id}</div>
        </div>

        <div class="label-footer">
          <span>${today}</span>
          <span>${formData.gender ? formData.gender.charAt(0) : ''}</span>
        </div>
      </div>
    `).join('');

    const htmlContent = `
      <html>
        <head>
          <title>Print Labels</title>
          <style>
            body { 
              font-family: Arial, sans-serif; 
              margin: 0; 
              padding: 0; 
              background: #fff; 
            }
            
            /* Industry standard blood vial label size: 50mm x 25mm */
            @page { 
              size: 50mm 25mm; 
              margin: 0; 
            }
            
            .label-container {
              width: 48mm;
              height: 23mm;
              padding: 1mm;
              box-sizing: border-box;
              page-break-after: always; /* Forces printer to roll to the next sticker */
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              overflow: hidden;
            }
            
            .label-header { 
              display: flex; 
              justify-content: space-between; 
              font-size: 8px; 
              font-weight: bold; 
              margin-bottom: 1px; 
            }
            
            .patient-name { text-transform: uppercase; }
            
            .test-name { 
              font-size: 9px; 
              font-weight: bold; 
              text-align: center; 
              white-space: nowrap; 
              overflow: hidden; 
              text-overflow: ellipsis; 
            }
            
            .barcode-box { 
              text-align: center; 
              margin: 1px 0; 
            }
            
            .barcode-box img { 
              height: 8mm; /* Very short barcode to fit the sticker */
              max-width: 100%; 
            }
            
            .barcode-text { 
              font-size: 7px; 
              font-weight: bold; 
              letter-spacing: 1px; 
            }
            
            .label-footer { 
              font-size: 7px; 
              display: flex; 
              justify-content: space-between; 
            }
          </style>
        </head>
        <body onload="setTimeout(function(){ window.print(); window.close(); }, 700);">
          ${labelsHtml}
        </body>
      </html>
    `;

    newWindow.document.write(htmlContent);
    newWindow.document.close();
  };



  return(
    <div className="registration-container fade-in" id="print-area">
      
      {/* PATIENT SEARCH (With Scanner Support) */}
      {(screenAction==="edit" || screenAction==="view") && (
        <div className="patient-search">
          <label>Scan Barcode or Search Patient</label>
          <input
            type="text"
            value={searchText}
            placeholder="Scan Request ID or Search by Name..."
            onChange={(e)=>searchPatients(e.target.value)}
            // --- SCANNER MAGIC HERE ---
            onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  if (patients.length === 1) selectPatient(patients[0]);
                }
            }}
            autoFocus
          />
          {showDropdown && patients.length>0 &&(
            <div className="patient-dropdown">
              {patients.map(p=>(
                <div key={p.patient_id} className="patient-item" onClick={()=>selectPatient(p)}>
                  {p.name} | {p.patient_id} | Req: {p.test_request_id}
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      <form className="luxury-form">
        
        {/* PATIENT DETAILS */}
        <div className="form-section-header">
          <h3>Patient Details</h3>
        </div>
        <div className="form-grid">
         <div className="input-box" style={{ position: 'relative' }}>
  <label>Patient ID / Name / Mobile</label>
  <input 
     type="text" 
     value={patientSearchText || formData.patient_id} 
     onChange={(e) => handlePatientSearch(e.target.value)} 
     placeholder="Search..."
     disabled={isDisabled}
     autoComplete="off"
  />
  {/* The Dropdown Menu */}
  {showPatientDropdown && patientResults.length > 0 && (
    <div className="patient-dropdown" style={{ top: '100%', left: 0, width: '100%', zIndex: 100 }}>
      {patientResults.map(p => (
        <div key={p.patient_id} className="patient-item" onClick={() => selectPatientForForm(p)}>
          {p.name} | {p.mobile} | {p.patient_id}
        </div>
      ))}
    </div>
  )}
</div>
          <div className="input-box"><label>Name</label><input type="text" value={formData.name} readOnly/></div>
          <div className="input-box"><label>Gender</label><input type="text" value={formData.gender} readOnly/></div>
          <div className="input-box"><label>Doctor</label><input type="text" value={formData.doctor_name} readOnly/></div>
        </div>

        {/* TEST REQUEST HEADER */}
        <div className="form-section-header">
          <h3>Lab Test Details</h3>
        </div>
        <div className="form-grid">
          <div className="input-box read-only"><label>Master Request ID</label><input type="text" value={formData.test_request_id} readOnly/></div>
          <div className="input-box"><label>Request Date</label><input type="date" name="test_date" value={formData.test_date} onChange={handleChange} disabled={isDisabled}/></div>
          <div className="input-box"><label>Priority</label>
            <select name="priority" value={formData.priority} onChange={handleChange} disabled={isDisabled}>
              <option>Normal</option><option>Urgent</option><option>Emergency</option>
            </select>
          </div>
        </div>

        {/* ADD TESTS TO CART (With Scanner Support) */}
        <div className="form-section-header" style={{ marginTop: '20px', borderTop: '1px solid #ccc', paddingTop: '10px' }}>
          <h4>Add Tests</h4>
        </div>



        
        {/* <div className="form-grid" style={{ alignItems: 'flex-end', backgroundColor: '#f9f9f9', padding: '15px', borderRadius: '8px' }}>
        
          <div className="input-box" style={{ position: "relative" , position: "relative", 
  overflow: "visible"}}>
  <label>Search Test</label>

  <input
    type="text"
    value={formData.current_test_id}
    placeholder="Search Test ID / Name..."
    onFocus={loadAllTests}   // ✅ SHOW ALL FIRST
    onChange={(e) => handleTestSearch(e.target.value)}
    ref={testInputRef}
    disabled={isDisabled}
    
  />


  {showTestDropdown && (
    <div
      style={{
        position: "absolute",
        top: "100%",
        left: 0,
        width: "100%",
        background: "#fff",
        border: "1px solid #ccc",
        borderRadius: "6px",
          zIndex: 9999,      
        maxHeight: "220px",
        overflowY: "auto"
      }}
    >
      {testSearchResults.map((t) => (
        <div
          key={t.test_id}
          onClick={() => selectTest(t)}
          style={{
            padding: "8px",
            cursor: "pointer",
            borderBottom: "1px solid #eee"
          }}
        >
          <strong>{t.test_name}</strong><br/>
          <small>{t.test_id} | {t.category} | ₹{t.fee}</small>
        </div>
      ))}
    </div>
  )}
</div>
          <div className="input-box"><label>Test Name</label><input type="text" value={formData.current_test_name} readOnly/></div>
          <div className="input-box"><label>Fees</label><input type="text" value={formData.current_fees} readOnly/></div>
          
          <button 
             type="button" 
             onClick={addTestToList} 
             disabled={isDisabled || !formData.current_test_name}
             style={{ padding: '10px 20px', height: '40px', backgroundColor: '#4b0082', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>
             + Add Test
          </button>
        </div> */}


<div className="form-grid" style={{ alignItems: 'flex-end', backgroundColor: '#f9f9f9', padding: '15px', borderRadius: '8px' }}>
          
          {/* Category Dropdown */}
          <div className="input-box">
            <label>Select Category</label>
            <select 
              value={formData.current_category || ""} 
              onChange={handleCategorySelect} 
              disabled={isDisabled}
            >
              <option value="">-- Choose Category --</option>
              {categoriesList.map(cat => (
                <option key={cat.test_category_id} value={cat.test_category_name}>
                  {cat.test_category_name}
                </option>
              ))}
            </select>
          </div>

          {/* Cascading Test Dropdown */}
  {/* Cascading Test Dropdown */}
          <div className="input-box">
            <label>Select Test</label>
            <select 
              value={formData.current_test_name || ""}
              onChange={handleTestDropdownSelect} 
              disabled={isDisabled || !formData.current_category}
            >
              <option value="">-- Choose Test --</option>
              {filteredTests.map(test => (
                <option key={test.test_id} value={test.test_name}> {/* 🔥 FIX: value is test_name */}
                  {test.test_name}
                </option>
              ))}
            </select>
          </div>

          {/* Auto-Fetched Fees */}
          <div className="input-box">
            <label>Fees (₹)</label>
            <input 
              type="text" 
              value={formData.current_fees} 
              readOnly 
              style={{ backgroundColor: '#e2e8f0', fontWeight: 'bold' }} 
            />
          </div>
          
          <button 
             type="button" 
             onClick={addTestToList} 
             disabled={isDisabled || !formData.current_test_name}
             style={{ padding: '10px 20px', height: '40px', backgroundColor: '#4b0082', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}>
             + Add Test
          </button>
        </div>

        {/* SELECTED TESTS TABLE */}
     {/* SELECTED TESTS TABLE & LABEL BUTTON */}
        {selectedTests.length > 0 && (
          <div style={{ marginTop: '20px' }}>
            
            {/* NEW HEADER WITH PRINT BUTTON */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
              <h4 style={{ margin: 0 }}>Selected Tests List</h4>
              <button 
                type="button" 
                onClick={printLabels} 
                style={{ padding: '6px 12px', backgroundColor: '#28a745', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold', fontSize: '12px' }}
              >
                🖨️ Print Vial Labels
              </button>
            </div>

            <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
              <thead style={{ backgrousndColor: '#e9ecef', borderBottom: '2px solid #ccc' }}>
                <tr>
                  <th style={{ padding: '10px' }}>Test ID</th>
                  <th style={{ padding: '10px' }}>Test Name</th>
                  <th style={{ padding: '10px' }}>Category</th>
                  <th style={{ padding: '10px' }}>Fees</th>
                  <th style={{ padding: '10px', textAlign: 'center' }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {selectedTests.map((test, index) => (
                  <tr key={index} style={{ borderBottom: '1px solid #ddd' }}>
                    <td style={{ padding: '10px' }}>{test.test_id}</td>
                    <td style={{ padding: '10px' }}>{test.test_name}</td>
                    <td style={{ padding: '10px' }}>{test.category}</td>
                    <td style={{ padding: '10px' }}>₹{test.fees}</td>
                    <td style={{ padding: '10px', textAlign: 'center' }}>
                      {!isDisabled && (
                         <button type="button" onClick={() => removeTestFromList(test.test_id)} style={{ color: 'red', border: 'none', background: 'none', cursor: 'pointer', fontWeight: 'bold' }}>X</button>
                      )}
                    </td>
                  </tr>
                ))}
                <tr style={{ borderTop: '2px solid #999', backgroundColor: '#f8f9fa' }}>
      <td colSpan="3" style={{ padding: '10px', textAlign: 'right', fontWeight: 'bold' }}>
        Total Amount:
      </td>
      <td style={{ padding: '10px', fontWeight: 'bold', color: '#27ae60' }}>
        ₹{selectedTests.reduce((sum, test) => sum + parseFloat(test.fees || 0), 0).toFixed(2)}
      </td>
      <td></td> {/* Empty cell under the Action column to keep grid aligned */}
    </tr>
              </tbody>
            </table>
          </div>
        )}

      </form>
    </div>
  );
};

export default LabTestRequest;

